import Button from './Button/Button';
import CheckBox from './CheckBox/CheckBox';
import DateTime from './dateTime/DateTime';
import Radio from './Radio/RadioButton';
import SelectBox from './SelectBox/SelectBox';
import Spinner from './Spinner/Spiner';
import TextInput from './TextInput/TextInput';
import Typography from './Typography/Typography';
import UploadButton from './UploadButton/UploadButton';
import Modal from './Modal/Modal';
import DynamicTable from "./Table/Table";
import TextArea from "./TextArea/TextArea";
import DynamicForm from './DynamicForm/DynamicForm';
import ComponentSpiner from './Spinner/ComponentSpiner'
class Component{
    static Button = Button;
    static CheckBox = CheckBox;
    static DateTime = DateTime;
    static Radio = Radio;
    static SelectBox = SelectBox;
    static TextInput = TextInput;
    static TextArea = TextArea;
    static Spinner = Spinner;
    static Typography = Typography;
    static UploadButton = UploadButton;
    static Modal = Modal;
    static DynamicTable = DynamicTable;
    static DynamicForm = DynamicForm;
    static ComponentSpiner = ComponentSpiner;
}
export default Component;